export default __webpack_public_path__ + "static/media/sciencegoldback@4x.11c41604.jpg";